// extracted by mini-css-extract-plugin
export default {"container":"dataList_container__fLSx1","title":"dataList_title__FgVyO","list":"dataList_list__vREV6"};